module.exports = __webpack_public_path__ + "static/media/037-boston pizza - gravenhurst.41fd3481.jpg";